<template>
  <div class="repetitor__banner">
    <div class="repetitor__banner_text">
      <h4>
        <span>Бесплатный пробный урок</span>
      </h4>
      <h6>Любой предмет на выбор!</h6>
    </div>

    <ul class="repetitor__banner_list no-laptop">
      <li>Диагностика пробелов в знаниях</li>
      <li>Составление диагностической карты</li>
      <li>Индивидуальный план обучения</li>
    </ul>

    <button
      class="m-btn"
      @click="$emit('open-free-modal')"
    >
      Попробовать
    </button>
  </div>
</template>

<script>
export default {
  name: 'RepetitorCatalogBanner',
};
</script>

<style scoped lang="scss">

.repetitor__banner {
  height: 100px;
  display: flex;
  align-items: center;
  padding-inline: 25px 20px;

  background-color: #6F53B4;
  background-image: url("/v2/catalog/repetitor/catalog/bg.webp");
  border-radius: 20px;

  @include media-down(tablet) {
    height: auto;
    flex-direction: column;
    gap: 24px;
    padding: 14px 16px 20px;
    margin-top: 20px;
    background-image: url("/v2/catalog/repetitor/catalog/bg-mob.webp");
  }

  h4 {
    position: relative;
    font-weight: 800;
    font-size: 26px;
    line-height: 120%;
    letter-spacing: -0.01em;
    text-transform: uppercase;
    font-feature-settings: 'pnum' on, 'lnum' on;
    color: $white-color;

    @include media-down(tablet) {
      margin-bottom: 6px;
      max-width: 300px;
      text-align: center;
    }

    &:before {
      content: '';
      display: block;
      position: absolute;
      width: 181px;
      height: 36px;
      left: -6px;
      top: -4px;
      background-color: $ege-orange;
      transform: rotate(-1deg);

      @include media-down(tablet) {
        top: -3px;
        left: 50%;
        transform: translateX(-50%);
      }
    }

    span {
      position: relative;
    }
  }

  h6 {
    font-weight: 500;
    font-size: 24px;
    line-height: 130%;
    font-feature-settings: 'pnum' on, 'lnum' on;
    color: $white-color;

    @include media-down(tablet) {
      line-height: 1;
      text-align: center;
    }
  }

  &_list {
    margin-left: 70px;
    display: flex;
    flex-direction: column;
    gap: 4px;

    li {
      padding-left: 20px;
      position: relative;
      font-family: 'Inter', 'TildaSans', sans-serif;
      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      line-height: 130%;
      letter-spacing: -0.01em;
      text-transform: lowercase;
      font-feature-settings: 'pnum' on, 'lnum' on;
      color: $gray-bg;

      &::before {
        content: '';
        display: block;
        width: 20px;
        height: 100%;
        background-image: url("/v2/catalog/repetitor/catalog/check.svg");
        background-position: center left;
        background-repeat: no-repeat;
        position: absolute;
        left: 0;
        top: 2px;
      }
    }
  }

  button {
    margin-left: auto;
    padding: 16px 30px 20px;
    background-color: #FF4F01;
    border-radius: 50px;

    font-weight: 700;
    font-size: 20px;
    line-height: 24px;
    font-feature-settings: 'pnum' on, 'lnum' on;
    color: $white-color;

    @include media-down(tablet) {
      width: min(312px, 100%);
      margin-right: auto;
      padding: 10px 10px 14px;
    }
  }
}

</style>
